import { render, staticRenderFns } from "./CgShopDailyManage.vue?vue&type=template&id=a35c7a34&scoped=true"
import script from "./CgShopDailyManage.vue?vue&type=script&lang=js"
export * from "./CgShopDailyManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35c7a34",
  null
  
)

export default component.exports